import { render } from "./DepartmentSearchModal.vue?vue&type=template&id=3bdb82b5&scoped=true"
import script from "./DepartmentSearchModal.vue?vue&type=script&lang=js"
export * from "./DepartmentSearchModal.vue?vue&type=script&lang=js"

import "./DepartmentSearchModal.vue?vue&type=style&index=0&id=3bdb82b5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdb82b5"]])

export default __exports__